function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.66761 0H8.82915C9.44299 0 9.85222 0.4 9.85222 1V8C9.85222 8.6 9.44299 9 8.82915 9H1.66761C1.05376 9 0.644531 8.6 0.644531 8V1C0.644531 0.4 1.05376 0 1.66761 0ZM2.69066 7H7.80604V2H2.69066V7ZM20.083 0H12.9214C12.3076 0 11.8984 0.4 11.8984 1V8C11.8984 8.6 12.3076 9 12.9214 9H20.083C20.6968 9 21.106 8.6 21.106 8V1C21.106 0.4 20.6968 0 20.083 0ZM13.9445 7H19.0599V2H13.9445V7ZM20.083 11H12.9214C12.3076 11 11.8984 11.4 11.8984 12V19C11.8984 19.6 12.3076 20 12.9214 20H20.083C20.6968 20 21.106 19.6 21.106 19V12C21.106 11.4 20.6968 11 20.083 11ZM13.9445 18H19.0599V13H13.9445V18ZM8.82915 11H1.66761C1.05376 11 0.644531 11.4 0.644531 12V19C0.644531 19.6 1.05376 20 1.66761 20H8.82915C9.44299 20 9.85222 19.6 9.85222 19V12C9.85222 11.4 9.44299 11 8.82915 11ZM2.69066 18H7.80604V13H2.69066V18Z",
  fill: "#201858"
});

var SvgDashboard = function SvgDashboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dashboard.4fc639ac.svg";
export { ForwardRef as ReactComponent };